export const SIGN_IN = 'auth:SIGN_IN'
export const SIGN_IN_SUCCESSFUL = 'auth:SIGN_IN_SUCCESSFUL'
export const SIGN_IN_FAILURE = 'auth:SIGN_IN_FAILURE'

export const SIGN_UP = 'auth:SIGN_UP'
export const SIGN_UP_SUCCESSFUL = 'auth:SIGN_UP_SUCCESSFUL'
export const SIGN_UP_FAILURE = 'auth:SIGN_UP_FAILURE'

export const UPDATE_EMAIL = 'auth:UPDATE_EMAIL'
export const UPDATE_EMAIL_SUCCESSFUL = 'auth:UPDATE_EMAIL_SUCCESSFUL'
export const UPDATE_EMAIL_FAILURE = 'auth:UPDATE_EMAIL_FAILURE'

export const GET_MY_DATA = 'auth:GET_MY_DATA'
export const GET_MY_DATA_SUCCESSFUL = 'auth:GET_MY_DATA_SUCCESSFUL'
export const GET_MY_DATA_FAILURE = 'auth:GET_MY_DATA_FAILURE'

export const LOGOUT = 'auth:LOGOUT'

export const SET_LANG = 'app:SET_LANG'

export const CLEAN_AUTH = 'auth:CLEAN_AUTH'

export const SIGN_IN_TEMPORARY_SUCCESS = 'auth:SIGN_IN_TEMPORARY'
